const VERSION = '2.6.4';
export function getVersionString() {
    return VERSION;
}
